import { render, staticRenderFns } from "./RankTable.vue?vue&type=template&id=208f4815&scoped=true&"
import script from "./RankTable.vue?vue&type=script&lang=js&"
export * from "./RankTable.vue?vue&type=script&lang=js&"
import style0 from "./RankTable.vue?vue&type=style&index=0&id=208f4815&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208f4815",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VIcon,VTextField})
